import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BaseDatasource } from '@shared/base/base.datasource';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { TablePaginatorDirective } from '@directives/table-paginator.directive';

@Component({
  selector: 'app-mai-material-bottom-table',
  standalone: true,
  imports: [CommonModule, RouterModule, MatPaginatorModule, NgxSkeletonLoaderModule, TablePaginatorDirective],
  templateUrl: './bottom-table.component.html',
  styleUrls: ['./bottom-table.component.scss'],
})
export class BottomTableComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @Input() baseDataTableComponent: BaseDatasource<any>;
  @Output() changePage = new EventEmitter<BaseDatasource<any>>();
  @Input() isFinishLoadingSubject: BehaviorSubject<boolean>;

  constructor(private activeRoute: ActivatedRoute, private paginatorNew: MatPaginatorIntl) {
    paginatorNew.itemsPerPageLabel = '';
    paginatorNew.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return '';
      }

      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

      return `Showing rows ${startIndex + 1} to ${endIndex} of ${length}`;
    };
  }

  isLoading: boolean = false;
  pageNumber: number | 1;

  ngOnInit(): void {
    // this.setPaginator();
    this.activeRoute.queryParams.subscribe((data) => {
      this.pageNumber = data.page;
    });
  }

  setPaginator() {
    if (this.paginator) {
      this.paginator._intl.itemsPerPageLabel = '';
      this.paginator._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0 || pageSize === 0) {
          return '';
        }

        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

        return `Showing rows ${startIndex + 1} to ${endIndex} of ${length}`;
      };
    }
  }

  handlePage($event: PageEvent) {
    this.baseDataTableComponent.pageSize = $event.pageSize;
    this.baseDataTableComponent.current_page = $event.pageIndex;
    this.changePage.emit(this.baseDataTableComponent);
  }
}
